 function formatDate() {
    var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth()+1;
    m = m < 10 ? '0'+m:m;
    var d = date.getDate();
    d = d<10?('0'+d):d;

    var h = date.getHours();
    h = h<10?('0'+h):h;

    var min = date.getMinutes();
    min = min<10?('0'+min):min;

    var s = date.getSeconds();
    s = s<10?('0'+s):s;

    return y+''+m+''+d+''+h+''+min+''+s+'';
}

export const AR = [
    {
        id: 0,
        key: 'OFX', // 关键的字段-报文节点名
        value: '',// 关键的字段-报文节点值
        isTitle:true, // 是否标题
        editDisenabled:false, // 是否开启编辑标题
        appendDisabled:false,// 是否启用新增按钮
        removeDisabled:true,// 是否启用删除按钮
        desc: 'OFX',
        children: [
            {
                id: 1,
                key: 'AUTHREQ',
                value: '',
                isTitle:true,
                editDisenabled:false,
                appendDisabled:false,
                removeDisabled:false,
                desc: 'AUTHREQ',
                children: [
                    { key: 'MSGTYPE', value: 'AR'},
                    { key: 'MSGTOKEN', value: '01' },
                    { key: 'TOKEN', value: '0' },
                    { key: 'FPXTRANSID', value: Math.random().toString().substring(2,18) },
                    { key: 'EXCHANGEID', value: 'EX00000155' },
                    { key: 'BATCH', value: '2625827743146024846' },
                    { key: 'NOOFORDERS', value: '1' },
                    // { key: 'TXNDATETIME', value: new Date() },
                    { key: 'TXNDATETIME', value:  formatDate()},
                    { key: 'FPXDATETIME', value: '20140618150218' },
                    { key: 'ENCRYPTVALUE', value: '55416F754F3831365A65686E7A597068476' }
                    ,
                    {
                        id: 2,
                        key: 'ORDERLIST',
                        value: '',
                        desc: 'ORDERLIST',
                        isTitle:true,
                        editDisenabled:false,
                        appendDisabled:false,
                        removeDisabled:false,
                        children: [
                           {key: "SERIALNO",value: "1"},
                            {key: "SELLERORDNO",value: "123456"},
                            {key: "SELLERID",value: "SE10001034"},
                            {key: "SELLERDESC", value: "<![CDATA[ SBI TEST SELLER1 ]]>" },
                            {key: "SELLERBANKID",value: "TEST0001"},
                            {key: "SELLERBRANCHCODE",value: "SAVING"},
                            {key: "SELLERACCNO",value: ""},
                            {key: "IBAN",value: "01"},
                            {key: "BUYERBANKID",value: "SBI0002"},
                            {key: "BUYERBRANCHCODE",value: "SBITWO"},
                            {key: "BUYERACCNO",value: ""},
                            {key: "BUYERNAME",value: "<![CDATA[BUYER]]>" },
                            {key: "BUYERID",value: ""},
                            {key: "MAKERNAME",value: "<![CDATA[MAKER]]>"},
                            {key: "OTHERPAYMENTDETAILS",value: "<![CDATA[]]>"},
                            {key: "CHARGETYPE",value: "AA"},
                            {key: "RESERVE1",value: "<![CDATA[]]>"},
                            {key: "RESERVE2",value: "<![CDATA[]]>"},
                            {key: "RESERVE3",value: "<![CDATA[]]>"},
                            {key: "RESERVE4",value: "<![CDATA[]]>"},
                            {key: "TRANSCURRENCY",value: "MYR"},
                            {key: "TRANSAMOUNT",value: "1.00"},
                            {key: "SETTLECURRENCY",value: "MYR"},
                            {key: "SETTLEAMOUNT",value: "1.00"},
                            {key: "FEECURRENCY", value: "MYR"},
                            {key: "FEEAMOUNT",value: "1.00"},
                            {key: "GST",value: "0.00"}
                        ]
                    },
                    {
                        id: 3,
                        key: 'RESPONSEURL',
                        value: '<![CDATA[https://uat.mepsfpx.com.my/FpxMain/processMesgFromSBIBanks.jsp]]>',
                        isTitle:false,
                        editDisenabled:false,
                        appendDisabled:false,
                        removeDisabled:false,
                        desc: 'RESPONSEURL',
                        children:[]
                    }
                ]
            },
        ]
    }
     ];

export const SR = [
    {
        id: 0,
        key: 'OFX', // 关键的字段-报文节点名
        value: '',// 关键的字段-报文节点值
        isTitle:true, // 是否标题
        editDisenabled:false, // 是否开启编辑标题
        appendDisabled:false,// 是否启用新增按钮
        removeDisabled:true,// 是否启用删除按钮
        desc: 'OFX',
        children: [
            {
                id: 1,
                key: 'AUTHREQ',
                value: '',
                isTitle:true,
                editDisenabled:false,
                appendDisabled:false,
                removeDisabled:false,
                desc: 'AUTHREQ',
                children: [
                    { key: 'MSGTYPE', value: 'SR'},
                    { key: 'MSGTOKEN', value: '' },
                    { key: 'TOKEN', value: '' },
                    { key: 'FPXTRANSID', value: '' },
                    { key: 'EXCHANGEID', value: '' },
                    { key: 'BATCH', value: '' },
                    { key: 'NOOFORDERS', value: '' },
                    { key: 'TXNDATETIME', value: '' },
                    { key: 'FPXDATETIME', value: '' },
                    { key: 'ENCRYPTVALUE', value: '' }
                    ,
                    {
                        id: 2,
                        key: 'ORDERLIST',
                        value: '',
                        desc: 'ORDERLIST',
                        isTitle:true,
                        editDisenabled:false,
                        appendDisabled:false,
                        removeDisabled:false,
                        children: [
                           {key: "SERIALNO",value: ""},
                            {key: "SELLERORDNO",value: ""},
                            {key: "SELLERID",value: ""},
                            {key: "SELLERDESC", value: "<![CDATA[ SBI TEST SELLER1 ]]>" },
                            {key: "SELLERBANKID",value: ""},
                            {key: "SELLERBRANCHCODE",value: ""},
                            {key: "SELLERACCNO",value: ""},
                            {key: "IBAN",value: ""},
                            {key: "BUYERBANKID",value: ""},
                            {key: "BUYERBRANCHCODE",value: ""},
                            {key: "BUYERACCNO",value: ""},
                            {key: "BUYERNAME",value: "<![CDATA[ ] ]>" },
                            {key: "BUYERID",value: ""},
                            {key: "MAKERNAME",value: "<![CDATA[ ] ]>"},
                            {key: "OTHERPAYMENTDETAILS",value: "<![CDATA[ ] ]>"},
                            {key: "CHARGETYPE",value: "AA"},
                            {key: "RESERVE1",value: "<![CDATA[ ] ]>"},
                            {key: "RESERVE2",value: "<![CDATA[ ] ]>"},
                            {key: "RESERVE3",value: "<![CDATA[ ] ]>"},
                            {key: "RESERVE4",value: "<![CDATA[ ] ]>"},
                            {key: "TRANSCURRENCY",value: "MYR"},
                            {key: "TRANSAMOUNT",value: ""},
                            {key: "SETTLECURRENCY",value: "MYR"},
                            {key: "SETTLEAMOUNT",value: ""},
                            {key: "FEECURRENCY", value: "MYR"},
                            {key: "FEEAMOUNT",value: "0.00"},
                            {key: "GST",value: "0.00"}
                        ]
                    },
                    {
                        id: 3,
                        key: 'RESPONSEURL',
                        value: '',
                        isTitle:false,
                        editDisenabled:false,
                        appendDisabled:false,
                        removeDisabled:false,
                        desc: 'RESPONSEURL',
                        children:[]
                    }
                ]
            },
        ]
    }
     ];



//////////////////
// WEBPACK FOOTER
// ./static/xml/XmlTemplate.js
// module id = null
// module chunks = 